import { createRouter, createWebHistory } from "vue-router";
import { getToken } from "@/services";
import { useAuthStore } from "@/store/auth";
import authRoutes from "@/modules/auth/routes";
import teacherRoutes from "@/modules/teachers/routes";
import coordinationRoutes from "@/modules/coordination/routes";
import reportsRoutes from "@/modules/reports/routes";
import serversRoutes from "@/modules/servers/routes";
import notificationsRoutes from "@/modules/notifications/routes";
import settingsRoutes from "@/modules/settings/routes";
import botRoutes from "@/modules/bot/routes";
import schoolRoutes from "@/modules/school/routes";
import peopleRoutes from "@/modules/people/routes";
import newsRoutes from "@/modules/news/routes";
import instructionsRoutes from "@/modules/instructions/routes";
import profile from "@/modules/profile/routes";
import legalNoticeRoutes from "@/modules/legal-notice/routes";
import schoolTransportRoutes from "@/modules/school-transport/routes";
import schoolMealsRoutes from "@/modules/school-meals/routes";
import aiRoutes from "@/modules/ai/routes";
import errorRoutes from "@/modules/errors/routes";

const routes = [
  ...authRoutes,
  ...errorRoutes,
  ...teacherRoutes,
  ...coordinationRoutes,
  ...notificationsRoutes,
  ...settingsRoutes,
  ...reportsRoutes,
  ...serversRoutes,
  ...botRoutes,
  ...peopleRoutes,
  ...schoolRoutes,
  ...newsRoutes,
  ...instructionsRoutes,
  ...profile,
  ...legalNoticeRoutes,
  ...schoolTransportRoutes,
  ...schoolMealsRoutes,
  ...aiRoutes,
  {
    path: "/app",
    component: () => import("@/dashboard/index"),
    name: "app.main",
    meta: {
      title: "Educasis - Dashboard",
      requiresAuth: true,
    },
  },
];

const router = createRouter({
  history: createWebHistory("educasis"),
  routes,
});

router.beforeEach(async (to, from, next) => {
  document.title = "Educasis";

  if (to.hasOwnProperty("meta") && to.meta.title) {
    document.title = to.meta.title;
  }

  const requiresAuth = to.matched.some((route) => route.meta.requiresAuth);
  const loginRoute = {
    name: "login",
    path: "/",
    query: { redirect: to.fullPath },
  };

  if (!requiresAuth) {
    return next();
  }

  if (!getToken()) {
    return next(loginRoute);
  }

  const authStore = useAuthStore();
  const ok = await authStore.ensureSession();

  if (!ok) {
    return next(loginRoute);
  }

  if (to.name !== "app.forbidden" && !authStore.canAccessRoute(to)) {
    return next({
      name: "app.forbidden",
      query: { from: to.fullPath },
    });
  }

  return next();
});

export default router;
